import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "@rebass/grid";
import { defaultTheme } from "@rentiohq/web-theme";
import { BeatLoader, ClipLoader } from "react-spinners";
import { ESpacings } from "../Grid";
import * as S from "./Loading.styled";
import { ELoadingSize } from "./Loading.types";
export var Loading = function (props) {
    var _a = props.asDots, asDots = _a === void 0 ? false : _a, _b = props.color, color = _b === void 0 ? defaultTheme.colors.neutral60 : _b, size = props.size;
    var loadingSize = size || asDots ? ELoadingSize.Small : ELoadingSize.Large;
    if (asDots) {
        return (_jsx(Flex, { py: ESpacings.base, justifyContent: "center", children: _jsx(BeatLoader, { size: loadingSize, color: color }) }));
    }
    return (_jsx(S.Loading, { size: loadingSize * 2, children: _jsx(ClipLoader, { size: loadingSize * 2, color: defaultTheme.colors.neutral60 }) }));
};
